import { IFormData } from '@/models/form-contact/form-contact.model';
import { isEqual } from 'lodash';
import { jwtDecode } from 'jwt-decode';
import { DecodedToken } from '@/models/store/auth/decoded-token.model';
import { StorageKey } from '@/enums/local-storage/storage-key.enum';

export const storageService = {
    setLocalData: (data: IFormData): void => {
        localStorage.setItem(
            'formData',
            JSON.stringify({
                data: JSON.stringify(data),
                timestamp: new Date().getTime(),
            }),
        );
    },

    removeLocalData: (key: string): void => {
        localStorage.removeItem(key);
    },

    compareTime(data: IFormData, key: string): boolean {
        const currentData = localStorage.getItem(key);
        if (currentData) {
            const parsedData = JSON.parse(currentData);

            if (!isEqual(JSON.parse(parsedData?.data).description, data.description)) return false;

            if (
                isEqual(JSON.parse(parsedData?.data).description, data.description) &&
                isEqual(JSON.parse(parsedData?.data).phone, data.phone) &&
                !(new Date().getTime() - parsedData?.timestamp <= 10000)
            )
                return false;
        } else return false;

        return false;
    },

    decodeToken: (token?: string): DecodedToken | string => {
        return token
            ? jwtDecode(token)
            : storageService.getLocalStorageData(StorageKey.TOKEN)
              ? jwtDecode(storageService.getLocalStorageData(StorageKey.TOKEN))
              : '';
    },

    setLocalStorageData: (key: StorageKey, data: string): void => {
        localStorage.setItem(key, data);
    },

    getLocalStorageData: (key: StorageKey): string => {
        return localStorage.getItem(key) ? (localStorage.getItem(key) as string) : '';
    },

    removeLocalStorageData: (key: StorageKey): void => {
        localStorage.removeItem(key);
    },

    checkAuthorization: (): boolean => {
        const token: string | null = localStorage.getItem('token');

        return token ? Number(String(jwtDecode(token).exp) + '000') > new Date().getTime() : false;
    },
};
